import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import WorkExplorer from "@/components/feature/WorkExplorer";
import { getCategoryById, getWorksByCategory } from "@/utils/gallery";

export default function CategoryPage() {
  const { categoryId = "" } = useParams();
  const category = getCategoryById(categoryId);

  useEffect(() => {
    if (category) {
      document.title = `${category.name} - 国模白露写真作品集`;
      const meta = document.querySelector('meta[name="description"]');
      if (meta) {
        meta.setAttribute(
          "content",
          `${category.name}分类收录国模白露精选模特写真摄影作品，${category.description}`
        );
      }
    }
  }, [category]);

  if (!category) {
    return (
      <div className="px-4 pb-24 pt-28 md:px-8 md:pt-32">
        <div className="mx-auto flex max-w-xl flex-col items-center rounded-lg border border-dashed border-background-300 bg-background-50 py-20 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-emotion-sad-line text-3xl" />
          </div>
          <h1 className="mt-5 text-lg font-semibold text-foreground-950">未找到该分类</h1>
          <p className="mt-2 text-sm text-foreground-500">
            你访问的分类不存在或已被移除，返回首页继续浏览其他分类作品。
          </p>
          <Link
            to="/"
            className="mt-6 flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const categoryWorks = getWorksByCategory(category.id);

  return (
    <div className="px-4 pb-20 pt-24 md:px-8 md:pb-28 md:pt-28">
      <div className="mb-6">
        <Breadcrumb items={[{ label: "作品分类" }, { label: category.name }]} />
      </div>

      <div className="mb-10 flex flex-col gap-6 overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:flex-row lg:items-stretch">
        <div className="relative w-full aspect-[16/9] lg:w-[380px] lg:shrink-0 lg:aspect-auto">
          <img
            src={category.cover}
            alt={`${category.name} - 国模白露分类封面`}
            title={`${category.name}写真作品集`}
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent lg:bg-gradient-to-r" />
        </div>
        <div className="flex flex-1 flex-col justify-center p-5 md:p-8">
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.3em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" />
            CATEGORY
          </p>
          <h1 className="text-2xl font-bold text-foreground-950 md:text-3xl">{category.name}</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            {category.description}
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-4 text-sm text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-image-2-line text-primary-500" />
              共 {categoryWorks.length} 组作品
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line text-primary-500" />
              持续更新中
            </span>
          </div>
        </div>
      </div>

      <WorkExplorer baseWorks={categoryWorks} resetKey={category.id} />
    </div>
  );
}